"use strict"

import React from "react"

import { logToServer } from "../ErrorBoundary"
import { getObjectsList } from "../Loaders"
import { updateSourceRegistrationWarning } from "../api"

const ConfigContext = React.createContext({})

export function withSourceRegistrationConfig(Component) {
  return function (props) {
    return (
      <ConfigContext.Consumer>
        {(configData) => <Component {...props} {...configData} />}
      </ConfigContext.Consumer>
    )
  }
}

const srcTypes = ["reactor", "system", "analyticalmethod", "nsrecipe"]

export default class SourceRegistrationConfigProvider extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      source_types: {},
      data_types: [],
      observation_types: [],
      ...Object.fromEntries(srcTypes.map((key) => [key, []])),
      ...Object.fromEntries(srcTypes.map((key) => [`${key}Tags`, []])),
      ...Object.fromEntries(srcTypes.map((key) => [`${key}Loading`, true])),
      queryTags: [],
      units: [],
      dcs_tables: [],
      dcsTablesLoading: true,
      unwatched: [],
    }

    this.getTablesLoad = this.getTablesLoad.bind(this)
    this.getSourceList = this.getSourceList.bind(this)
    this.getSourceTags = this.getSourceTags.bind(this)
    this.getSourceInfo = this.getSourceInfo.bind(this)
  }

  componentDidMount() {
    this.getTablesLoad()

    getObjectsList(`/warehouse/source_types/`)
      .then((source_types) => {
        let info = {}
        source_types.forEach((st) => (info[st.name.toLowerCase()] = st.id))
        this.setState({
          source_types: info,
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          sourceTypesErr: err,
        })
      })

    getObjectsList("/warehouse/tags/")
      .then((tags) => {
        this.setState({
          queryTags: tags.sort((a, b) => (a.name > b.name ? 1 : -1)),
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          queryTagsErr: err,
        })
      })

    getObjectsList("/warehouse/units/")
      .then((units) => {
        this.setState({
          units: units.filter((unit) => unit.name !== "Unknown").sort((a, b) => (a.name > b.name ? 1 : -1)),
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          unitsErr: err,
        })
      })

    getObjectsList(`/warehouse/dcs_tags/data_types/`)
      .then((data_types) => {
        this.setState({
          observation_types: data_types["observation_types"],
          data_types: data_types["data_types"].filter((dt) => dt !== "Unknown"),
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          dataTypesErr: err,
        })
      })
  }

  getTablesLoad(type = false) {
    if (type) {
      this.setState({
        [`${type}Loading`]: true,
        dcsTablesLoading: true,
      })
    } else {
      this.setState({
        dcsTablesLoading: true,
      })
    }

    updateSourceRegistrationWarning()

    getObjectsList("/warehouse/dcs_tables/detailed/")
      .then((dcs_tables) => {
        const update_obj = {
          dcs_tables: dcs_tables,
          dcsTablesLoading: false,
        }
        if (type) {
          this.setState({
            ...update_obj,
            [`${type}Loading`]: false,
          })
        } else {
          this.setState(update_obj)
        }
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        const update_obj = {
          dcsErr: err,
          dcsTablesLoading: false,
        }
        if (type) {
          this.setState({
            ...update_obj,
            [`${type}Loading`]: false,
          })
        } else {
          this.setState(update_obj)
        }
      })

    getObjectsList(`/warehouse/dcs_tables/unwatched/`)
      .then((unwatched) => {
        this.setState({
          unwatched: unwatched,
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          unwatchedErr: err,
        })
      })
  }

  getSourceInfo(source_type) {
    this.getSourceList(source_type)
    this.getSourceTags(source_type)
  }

  getSourceList(source_type) {
    getObjectsList(`/warehouse/sources/${source_type}/type/`)
      .then((sources) => {
        this.setState({
          [source_type]: sources,
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          [`${source_type}Err`]: err,
        })
      })
  }

  getSourceTags(source_type) {
    this.setState({
      [`${source_type}Loading`]: true,
    })
    getObjectsList(`/warehouse/sources/${source_type}/tags/`)
      .then((sourceTags) => {
        this.setState({
          [`${source_type}Tags`]: sourceTags,
          [`${source_type}Loading`]: false,
        })
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
        this.setState({
          [`${source_type}TagsErr`]: err,
          [`${source_type}Loading`]: true,
        })
      })
  }

  render() {
    return (
      <ConfigContext.Provider
        value={{
          sourceTypes: this.state.source_types,
          data_types: this.state.data_types,
          observation_types: this.state.observation_types,
          getSourceTags: (type) => this.state[`${type}Tags`],
          getSourceLoading: (type) => this.state[`${type}Loading`],
          getSources: (type) => this.state[`${type}`],
          getSourceInfo: this.getSourceInfo,
          queryTags: this.state.queryTags,
          units: this.state.units,
          dcs_tables: this.state.dcs_tables,
          dcsTablesLoading: this.state.dcsTablesLoading,
          unwatched: this.state.unwatched,
          getTablesLoad: this.getTablesLoad,
        }}
      >
        {this.props.children}
      </ConfigContext.Provider>
    )
  }
}
